var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentElement,_vm._b({tag:"component",staticClass:"lottie-animation-container",style:(_vm.getCurrentStyle),attrs:{"data-id":_vm.elementId},on:{"mouseenter":_vm.hoverStarted,"mouseleave":_vm.hoverEnded}},'component',_vm.$attrs,false),[_c('span',{staticClass:"hidden"})])
}
var staticRenderFns = []

export { render, staticRenderFns }